import { createFileRoute } from "@tanstack/react-router";
import SelfCameraCosmetics from "@/features/assessments/pages/self-camera-cosmetics/SelfCameraCosmetics";

export const Route = createFileRoute("/$locale/$partner/_cosmetic/self-camera-cosmetics")({
	component: SelfCameraCosmetics,
});
